import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-674f928e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "show-box" }
const _hoisted_2 = ["data-clipboard-text"]

import {onMounted, ref} from 'vue';
import {UrlFieldType} from '@/components/business/crud/interface/FieldType';
import ClipboardJS from "clipboard";
import {message} from "ant-design-vue";
import {WidgetInfo} from "@/components/business/crud/widgets/WidgetContainer";
import { ColumnEdit } from '@/components/business/crud/widgets/TableWidgetContainer';


export default /*#__PURE__*/_defineComponent({
  __name: 'UrlTable',
  props: {
    columnEdit: { type: Function },
    propName: {},
    widget: {},
    info: {},
    data: {}
  },
  setup(__props: any) {

const props = __props;

const btnRef = ref<HTMLElement>();

onMounted(() => {
  if (btnRef.value) {
    new ClipboardJS(btnRef.value);
  }
})

function ellipsis(text: string, max: number) {
  if (text.length <= max) {
    return text;
  } else {
    return text.slice(0, max - 3) + "..."
  }
}
function onCopy() {
  message.success('已复制');
}

return (_ctx: any,_cache: any) => {
  const _component_a_tooltip = _resolveComponent("a-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_tooltip, {
      title: _ctx.data[_ctx.propName]?.length > 18 ? _ctx.data[_ctx.propName] : '',
      placement: "top"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          ref_key: "btnRef",
          ref: btnRef,
          "data-clipboard-text": _ctx.data[_ctx.propName] || '',
          onClick: onCopy
        }, _toDisplayString(ellipsis(_ctx.data[_ctx.propName] || '', 18)), 9, _hoisted_2)
      ]),
      _: 1
    }, 8, ["title"])
  ]))
}
}

})